var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowPopover = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 29",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15 0 14.142 14.142L15 28.284.858 14.142z"
})));
SvgArrowPopover.viewBox = '0 0 30 29';
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowPopover);
export default ForwardRef;